/**
 * action types
 */

export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';
export const MOVE_WISHLISTITEM_TO_CART = 'MOVE_WISHLISTITEM_TO_CART';
export const FINAL_PAYMENT = 'FINAL_PAYMENT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_ERROR = 'SET_ERROR';
export const SET_USER_DATA = 'SET_USER_DATA';


// WEBPACK FOOTER //
// ./src/actions/types.js